var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgAuth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 478,
    height: 597,
    viewBox: "0 0 478 597",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10_10",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 478,
    height: 597
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 478,
    height: 597,
    rx: 14,
    fill: "#FFC8C8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-42.4814 -59.7549C-52.1853 -76.3354 -48.6133 -96.2687 -33.8229 -108.073L-13.3635 -124.401C-6.01006 -130.27 3.4482 -133.551 13.4371 -133.699L447.28 -140.127C465.712 -140.4 482.939 -130.039 490.348 -114.224L574.766 65.9816C586.112 90.2016 570.286 116.631 542.448 119.951L125.018 169.744C106.488 171.954 87.8843 162.994 78.8092 147.488L-42.4814 -59.7549Z",
    fill: "#2A5FF1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAuth);
export default __webpack_public_path__ + "static/media/bg-auth.d204a1ca63b4d47351d6532e7c8eb1a8.svg";
export { ForwardRef as ReactComponent };